<template>
    <div class="IndustryNews">
        <mediaCenter tabIndex="1"></mediaCenter>
        <div :class="isMobile?'':'industryBox'">
            <template v-if="!isMobile">
                <div class="industryList clearfix" v-for="(item,index) in industryNewsList" :key="index">
                <div class="fl insLeft">
                    <div class="fl day">{{item.addtime.split('-')[2]}}/</div>
                    <div class="fl yearMon">
                        <p>{{item.addtime.split('-')[1]}}月</p>
                        <p>{{item.addtime.split('-')[0]}}</p>
                    </div>
                </div>
                <div class="fl insRight">
                    <p class="title curp" @click="jumpToDetails(item.id)">{{item.title}}</p>
                    <p class="desc overh2" v-html="item.descirbes"></p>
                    <p class="lookInfo" @click="jumpToDetails(item.id)">查看详情</p>
                </div>
            </div>
            </template>
            <template v-if="isMobile">
                <div class="industryItem" v-for="(item,index) in industryNewsList" :key="index">
                    <p class="titles" @click="jumpToDetails(item.id)">{{item.title}}</p>
                    <p class="descs overh2" v-html="item.descirbes"></p>
                    <p class="textr c99 mt5">{{item.addtime}}</p>
                </div>
            </template>
            <div class="" v-if="industryNewsList.length==0">
                <el-empty description="暂无数据"></el-empty>
            </div>
            <el-pagination class="pageBox" v-if="industryNewsList.length!=0" background @current-change="handleCurrentChange" :current-page.sync="currentPage" :layout="isMobile?'prev, pager, next':'prev, pager, next, jumper'" :pager-count="isMobile?'5':'7'" :total="total"></el-pagination>
        </div>
    </div>
</template>

<script>
    import mediaCenter from '@/components/mediaCenter'
	export default {
		name:'IndustryNews',
        components: {
            mediaCenter
        },
        data() {
            return {
                industryNewsList: [],
                currentPage:1,
                pageindex:1,
                total:0
            }
        },
        mounted(){
            this.getIndustryNews()
        },
        methods: {
             //获取行业资讯列表
             getIndustryNews(){
                this.Request({
                    url: '/webindex/news/industryNewsList',
                    method: 'get',
                    data:{
                        pageindex:this.pageindex,
                        pagesize:10
                    }
                }).then((data) => {
                    if(data.rows && data.rows.length > 0){
                        this.industryNewsList = data.rows
                        this.total = data.total
                    }
                })
            },
            jumpToDetails(id) {
                // this.$router.push({
                //     path: '/mediaCenter/IndustryNewsDetails?id='+id,
                // })
                window.location.assign('/mediaCenter/IndustryNewsDetails?id='+id)
            },
            handleCurrentChange(val){
                this.currentPage = val
                this.pageindex=val
                this.getIndustryNews()
            }

        }
	}
</script>

<style scoped>
    .industryBox{
        width: 1200px;
        margin: 0 auto;
        margin-top: 17px;
    }
    .industryList{
        padding: 35px 30px 35px 28px;
        border-bottom: 1px solid #E1E1E1;
    }
    .industryItem{
        padding: 20px;
        border-bottom: 1px solid #E1E1E1;
    }
    .insLeft{
        padding-right: 38px;
        border-right: 1px solid #E1E1E1;
        padding-top: 47px;
        padding-bottom: 60px;
    }
    .day{
        font-size: 42px;
    }
    .yearMon{
        font-size: 14px;
        color: #333;
        margin-top: 10px;
        margin-left: 5px;
    }
    .insRight{
        padding-left: 50px;
        width: 990px;
    }
    .title{
        font-size: 20px;
        font-weight: 400;
    }
    .titles{
        font-size: 18px;
    }
    .desc{
        color: #666;
        margin-top: 27px;
        line-height: 28px;
    }
    .descs{
        color: #666;
        margin-top: 15px;
        line-height: 28px;
    }
    .lookInfo{
        margin-top: 24px;
        color: #247CD6;
        cursor: pointer;
    }
    .pageBox{
        text-align: center;
        margin-top: 35px;
        margin-bottom: 42px;
    }
</style>